<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
    <rect width="11" height="11" fill=""/>
  </svg>
</template>

<script>
  export default {
    name: "rectangleIcon"
  }
</script>

<style scoped>
  .v-icon--is-component {
    width: 11px;
    height: 11px;
    margin: 0 10px;
    border-radius: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/Elements/icons/rectangleIcon.vue